<template>
  <div
    class="container-fluid"
    v-if="auth == 'loggedin' || token != null || token != undefined"
  >
    <b-card
      border-variant="secondary"
      class="mt-5">
      <b-card-body>
            <!-- // VISSZA -->
        <b-row>
        <h1 class="text-center h1cimke">Részletek</h1>
            <b-button
                size="sm"
                variant="info"
                class="btn float-left"
                @click="$router.push({ name: 'Munkalap' })"
                ><b-icon-plus-circle></b-icon-plus-circle>
                Vissza
            </b-button>
        </b-row>
        <b-row>
            <b-col class="col-sm-1 mt-2">
                <p>Név: </p>
                <p>Cím: </p>
                <p>Telefon: </p>
                <p>Email: </p>
            </b-col>
            <b-col>
                <p>{{list.partner.nev}}</p>
                <p>{{list.partner.irszam}} {{list.partner.varos}} {{list.partner.cim}}</p>
                <p>{{list.partner.telefon}}</p>
                <p>{{list.partner.email}}</p>
            </b-col>
        </b-row>
      </b-card-body>
    </b-card>

    <b-card
      border-variant="secondary"
      class="text-center mt-1"
    >
      <!-- // TABLE -->
      <div class="mt-3">
        <b-table class="labelsize table-striped" hover :items="cikkTetel" :fields="fields" :key="cikkTetel.id">
        </b-table>
      </div>
        <b-row class="float-right" style="margin-right: 50px; color: gray;">
            <h4 >
                Összesen: {{list.summa}}
            </h4>
        </b-row>
    </b-card>
  </div>
</template>

<script>
import axios from 'axios'
import router from '../router'
import VueHtml2pdf from 'vue-html2pdf'
import jwtDecode from 'jwt-decode'
import moment from 'moment'

export default {
  components: {
    VueHtml2pdf
  },
  data () {
    const token = localStorage.usertoken
    const decoded = jwtDecode(token)
    return {
      token: localStorage.usertoken,
      auth: '',
      userType: decoded.usertype,
      list: [],
      cikkTetel: [],
      fields: [
        {
          key: 'cikkModel.nev',
          label: 'Megnevezés',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'cikkModel.vonalkod',
          label: 'Vonalkód',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'cikkModel.cikkszam',
          label: 'Cikkszám',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        },
        {
          key: 'mennyiseg',
          label: 'Mennyiség',
          sortable: true,
          sortDirection: 'desc'
          // thClass: 'text-left'
        },
        {
          key: 'bruttofogyar',
          label: 'Egységár',
          sortable: true,
          sortDirection: 'desc',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'osszesen',
          label: 'Összesen',
          sortable: true,
          sortDirection: 'desc',
          tdClass: 'text-right',
          thClass: 'text-right'
        }
      ]
    }
  },
  methods: {
    redirect: function (link, target = '_blank') {
      window.open(link, target)
    },
    loadList () {
      let id = this.$route.params.id
      let payload = {}
      if (!this.token) {
        router.push({ name: 'Login' })
      } else {
        payload.token = this.token
        payload.userType = this.userType
        payload.id = id
        axios.post(process.env.ROOT_API + '/munkalap/preview', {payload})
          .then(res => {
            console.log(res.data)
            this.list = res.data
            for (var el in res.data.munkalapTetelModels) {
              let temp = {}
              temp = res.data.munkalapTetelModels[el]
              temp.osszesen = parseInt(temp.mennyiseg) * parseInt(temp.bruttofogyar)
              this.cikkTetel.push(temp)
              console.log(this.cikkTetel)
            }
          })
          .catch(err => {
            console.log(err)
          })
      }
    }
  },
  mounted: function () {
    this.loadList()
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MunkalapPreview.vue